import {UPDATE_GROUP_NEWS_START} from "../../types";

export const update_group_news = (payload) => ({
    type: UPDATE_GROUP_NEWS_START,
    payload,
});
